import React,{useMemo,useState} from 'react';
import {
  Box,
  Button,
  makeStyles,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { WhitePopup, WhitePopupAction, WhitePopupContent, WhitePopupTitle } from 'src/components/PopUp/PopUpComponents/WhitePopup';
import { useQuery } from '@apollo/client';
import { BROKERS } from 'src/graphql/queries/brokers';
import { brokersQuery, brokerType } from 'src/types/broker-types';
import useRouteManager from 'src/utils/customHook/useRouteManager';
import { capitalize } from 'src/utils/utils';
import { useHistory } from 'react-router';
import PlainLayout from 'src/layouts/PlainLayout';

const useStyles = makeStyles((theme) => ({
  root:{}
}));

const InvalidBrokerPage: React.FC= () => {

  const classes = useStyles();
  const history = useHistory();
  const { brokerNameOnURL } = useRouteManager()
  const [selectedBroker,setSelectedBroker] = useState("default")
  const { data:Brokers } = useQuery<brokersQuery>(BROKERS)

  const toBroker = (broker:string) => {
    let path = window.location.pathname
    let path_l = path.split("/")
    path_l[1] = broker.toLowerCase()
    let newPath = path_l.join("/")

    // history.replace(newPath)
    window.location.pathname = newPath
  }

  const brokers = useMemo(()=>{
    if (Brokers?.brokers.__typename === "Brokers") {
      setSelectedBroker(Brokers.brokers.brokers[0]?.name || "default")
      return Brokers.brokers.brokers
    } else return []
  },[Brokers])

  const BrokerSelect = (b:brokerType) => (
    <MenuItem key={b.brokerID} value={b.name}>
      {b.name}
    </MenuItem>
  )

  return (
    <div className={classes.root}>
      <PlainLayout>
        <WhitePopup
          open={true}
          variant="response"
          color="primary"
          icon="awareSecondary"
          onClose={()=>{}}
          useDark
        >
          <WhitePopupTitle>
            
            <Typography style={{color:"white"}} variant="h6">
              {`ไม่พบ ${capitalize(brokerNameOnURL) || "Broker"} ในระบบ Finnize`}
            </Typography>
          </WhitePopupTitle>
          <WhitePopupContent>
            <Typography color="textSecondary">
              ขออภัยเราไม่พบ Broker ที่คุณกำลังค้นหา
            </Typography>
            <Box pt={1}/>
            <Typography color="textSecondary">
              โปรดเลือก Broker จากด้านล่างนี้อีกครั้ง
            </Typography>
            <Box pt={2}/>
            <TextField
              variant="outlined"
              value={selectedBroker}
              onChange={(e)=>setSelectedBroker(e.target.value)}
              select
              fullWidth
              size="small"
            >
              <MenuItem key={'default'} value={'default'} disabled>
                <Typography>
                  {'เลือก Broker ที่คุณกำลังค้นหา'}
                </Typography>
              </MenuItem>
              {brokers.map(BrokerSelect)}
            </TextField>
          </WhitePopupContent>
          <WhitePopupAction>
            <Button
              variant="contained"
              color="primary"
              style={{textTransform:"none"}}
              onClick={()=>toBroker(selectedBroker)}
            >
              <Typography style={{color:"white"}}>
                {`เข้าสู่ Finnize สำหรับ ${capitalize(selectedBroker)}`}
              </Typography>
            </Button>
          </WhitePopupAction>
        </WhitePopup>
      </PlainLayout>
    </div>
  )
}

export default InvalidBrokerPage;
